var map = {
	"./ANTS/Logo_Web.png": 264,
	"./ANTS3/Logo_Web.png": 265,
	"./ANTS4/Logo_Web.png": 266,
	"./Promotech/Logo_Web.png": 267,
	"./TestBox/1/Logo_Web.png": 524,
	"./TestBox/2/Logo_Web.png": 525,
	"./TestBox/3/Logo_Web.png": 526,
	"./True/Logo_Web.png": 268
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 307;